import React from "react";
import AuctionBanner from './AuctionBanner';
import LeftSection from './LeftSection';
import SearchbarSection from './SearchbarSection';
import RightSection from './RightSection';
import Iframe from './Iframe';

const Home = () => {
  console.log("Home rendered");
  return (
    <div className="container-fluid p-0">
      <div className="row no-gutters">
        <div className="col-2 d-none d-md-block">
          <LeftSection />
        </div>
        <div className="col-8">
          <SearchbarSection />
          <AuctionBanner />
          <Iframe />
        </div>
        <div className="col-2 d-block">
          <RightSection />
        </div>
      </div>
    </div>
  );
};

export default Home;